<mat-form-field class="w-100" [appearance]="appearance()">
  @if (label()) {
  <mat-label>{{ label() }}</mat-label>
  }
  
  <input
    matInput
    type="text"
    [placeholder]="placeholder()"
    [value]="searchText()"
    (input)="onInputChange($event)"
    (focus)="onFocus()"
    [matAutocomplete]="auto"
    [disabled]="isDisabled"
    [required]="required()"
  />

  @if (hasSelection && !isDisabled) {
  <button
    matSuffix
    mat-icon-button
    (click)="clearSelection(); $event.stopPropagation()"
    type="button"
    tabindex="-1"
  >
    <mat-icon>close</mat-icon>
  </button>
  }

  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayFn.bind(this)"
    (optionSelected)="onSelectionChange($event.option.value)"
    (opened)="onPanelOpen()"
    (closed)="onPanelClose()"
  >
    @for (option of filteredOptions(); track option.value) {
    <mat-option [value]="option.value" [disabled]="option.disabled">
      {{ option.label }}
      @if (showCounts() && option.count !== undefined) {
        <span class="count">({{ option.count }})</span>
      }
    </mat-option>
    } @empty {
    <mat-option disabled>No options found</mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
